var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _g3, _g4, _path14, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Banner",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 601.586,
    height: 353.869,
    viewBox: "0 0 601.586 353.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background_1",
    "data-name": "background 1",
    d: "M575,353.566H.769c0-6.1-.188-12.5-.376-18.694-.523-17.379-1.062-35.34,2.244-51.824a79.082,79.082,0,0,1,8.329-23.379,64.392,64.392,0,0,1,17-19.7c17.508-13.642,33.86-21.461,51.173-29.742,17.984-8.6,36.578-17.5,59.686-33.894,26.407-18.743,54.04-44.2,84.475-77.844A427.918,427.918,0,0,1,273.821,50.53,278.53,278.53,0,0,1,320.2,20.3C346.654,6.827,372.881,0,398.152,0A134.027,134.027,0,0,1,426.5,2.995a124.4,124.4,0,0,1,22.777,7.263c8.288,3.572,15.7,9.688,23.32,19.26a274.542,274.542,0,0,1,19.382,29.558C500.494,73.3,509.3,88,520.881,101.128a119.477,119.477,0,0,0,19.63,18.035,103.362,103.362,0,0,0,25.215,13.39,37.812,37.812,0,0,1,14.38,9.587,58.992,58.992,0,0,1,10.7,16.29,122.771,122.771,0,0,1,9.419,36.857,247.994,247.994,0,0,1,.447,47.3,373.651,373.651,0,0,1-8.436,54.008A439.375,439.375,0,0,1,575,353.556ZM112.065,129.039a31.159,31.159,0,0,1-24.6-11.741,41.968,41.968,0,0,1-9.173-17.843A42.822,42.822,0,0,1,78.375,80.7C80.913,69.016,87.836,56.875,98.4,45.581a115.859,115.859,0,0,1,34.445-25.234,59.3,59.3,0,0,1,24.95-5.827,43.528,43.528,0,0,1,18.826,4.049,31.125,31.125,0,0,1,13,11.369,29.366,29.366,0,0,1,4.37,15.88,46.382,46.382,0,0,1-5.175,20.114,131.218,131.218,0,0,1-14.185,22.461,145.684,145.684,0,0,1-19.11,20.292,100.324,100.324,0,0,1-21.651,14.692A50.413,50.413,0,0,1,112.065,129.039Z",
    transform: "translate(-0.002 0)",
    fill: "#f2f6ff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ilustra\\xE7\\xE3o_-_Banner",
    "data-name": "Ilustra\\xE7\\xE3o - Banner",
    transform: "translate(23.146 4.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5307",
    "data-name": "Grupo 5307",
    transform: "translate(51.007 0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5297",
    "data-name": "Grupo 5297",
    transform: "translate(87.841 96.07)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1342",
    "data-name": "Ret\\xE2ngulo 1342",
    width: 328.206,
    height: 215.346,
    rx: 1.486,
    transform: "translate(20.831)",
    fill: "#131c5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1343",
    "data-name": "Ret\\xE2ngulo 1343",
    width: 311.708,
    height: 190.151,
    rx: 0.756,
    transform: "translate(29.087 9.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1344",
    "data-name": "Ret\\xE2ngulo 1344",
    d: "M0,0H369.882a0,0,0,0,1,0,0V34.115a4.089,4.089,0,0,1-4.089,4.089H4.089A4.089,4.089,0,0,1,0,34.115V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 215.346)",
    fill: "#131c5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1345",
    "data-name": "Ret\\xE2ngulo 1345",
    d: "M0,0H77.278a0,0,0,0,1,0,0V13.151A2.044,2.044,0,0,1,75.233,15.2H2.044A2.044,2.044,0,0,1,0,13.151V0A0,0,0,0,1,0,0Z",
    transform: "translate(146.302 215.346)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5304",
    "data-name": "Grupo 5304",
    transform: "translate(132.007 115.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5299",
    "data-name": "Grupo 5299",
    transform: "translate(2.7 48.229)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5140",
    "data-name": "Caminho 5140",
    d: "M92.18,57.089v57.055a7.312,7.312,0,0,1-7.3,7.344H74.894a7.36,7.36,0,0,1-7.354-7.344V57.089A7.342,7.342,0,0,1,74.894,49.8h9.989A7.294,7.294,0,0,1,92.18,57.089Z",
    transform: "translate(-67.54 -6.79)",
    fill: "#36aaff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5141",
    "data-name": "Caminho 5141",
    d: "M96.025,59.24V96.2a7.358,7.358,0,0,1-7.344,7.344h-10a7.312,7.312,0,0,1-7.3-7.344V59.24a7.258,7.258,0,0,1,7.3-7.288h10A7.3,7.3,0,0,1,96.025,59.24Z",
    transform: "translate(-35.457 11.158)",
    fill: "#36aaff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5142",
    "data-name": "Caminho 5142",
    d: "M99.864,55.7v70.071a7.348,7.348,0,0,1-7.3,7.344H82.522a7.312,7.312,0,0,1-7.3-7.344V55.7a7.3,7.3,0,0,1,7.3-7.3H92.567A7.338,7.338,0,0,1,99.864,55.7Z",
    transform: "translate(-3.424 -18.422)",
    fill: "#36aaff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5143",
    "data-name": "Caminho 5143",
    d: "M103.695,60.978V82.161a7.31,7.31,0,0,1-7.288,7.344H86.352a7.34,7.34,0,0,1-7.288-7.344V60.978a7.34,7.34,0,0,1,7.288-7.344H96.407A7.31,7.31,0,0,1,103.695,60.978Z",
    transform: "translate(28.617 25.192)",
    fill: "#36aaff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5144",
    "data-name": "Caminho 5144",
    d: "M107.534,52.5V152.552a7.31,7.31,0,0,1-7.288,7.344h-10a7.352,7.352,0,0,1-7.344-7.344V52.5a7.306,7.306,0,0,1,7.344-7.3h10A7.264,7.264,0,0,1,107.534,52.5Z",
    transform: "translate(60.65 -45.198)",
    fill: "#36aaff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5298",
    "data-name": "Grupo 5298",
    transform: "translate(0 18.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5145",
    "data-name": "Caminho 5145",
    d: "M92.18,67.586v29.77a7.312,7.312,0,0,1-7.3,7.344H74.894a7.36,7.36,0,0,1-7.354-7.344V51.813a43.367,43.367,0,0,1,7.513.7A16.149,16.149,0,0,1,81.911,55c2.813,2.1,4.111,5.672,6.167,8.531A16.108,16.108,0,0,0,92.18,67.586Z",
    transform: "translate(-67.54 -8.373)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5146",
    "data-name": "Caminho 5146",
    d: "M86.9,58.553A25.446,25.446,0,0,0,96.025,53.1V86.65a7.358,7.358,0,0,1-7.344,7.344h-10a7.312,7.312,0,0,1-7.3-7.344V60.767A36.722,36.722,0,0,0,86.9,58.553Z",
    transform: "translate(-35.457 2.333)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5147",
    "data-name": "Caminho 5147",
    d: "M94.192,61.685c2.373,5.625,3.027,12,5.672,17.455v24.042a7.348,7.348,0,0,1-7.3,7.344H82.522a7.312,7.312,0,0,1-7.3-7.344V53.257a9.254,9.254,0,0,1,3.2-1.729C84.951,49.482,91.492,55.369,94.192,61.685Z",
    transform: "translate(-3.424 -14.199)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5148",
    "data-name": "Caminho 5148",
    d: "M97.481,58.259a22.318,22.318,0,0,0,6.214-1.458V68.36A7.31,7.31,0,0,1,96.407,75.7H86.352a7.34,7.34,0,0,1-7.288-7.344V55.288A34.691,34.691,0,0,0,97.481,58.259Z",
    transform: "translate(28.617 20.623)",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5149",
    "data-name": "Caminho 5149",
    d: "M107.534,47.164v88.983a7.31,7.31,0,0,1-7.288,7.344h-10a7.352,7.352,0,0,1-7.344-7.344V95.893c.43-3.728.8-7.5,1.289-11.232,1.355-9.942,3.728-20.1,9.942-28.042A28.186,28.186,0,0,1,107.534,47.164Z",
    transform: "translate(60.65 -47.164)",
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1346",
    "data-name": "Ret\\xE2ngulo 1346",
    width: 110.569,
    height: 23.248,
    rx: 1.244,
    transform: "translate(183.729)",
    fill: "#5a70fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1347",
    "data-name": "Ret\\xE2ngulo 1347",
    width: 110.569,
    height: 23.248,
    rx: 1.244,
    transform: "translate(178.978 2.64)",
    fill: "#b6c3e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5150",
    "data-name": "Caminho 5150",
    d: "M106.042,49.67a5.662,5.662,0,0,0-.654-7.242,5.6,5.6,0,0,0-8.045,0,5.682,5.682,0,0,0,7.242,8.7l5.233,5.242,1.458-1.458Zm-2.112-.645a3.647,3.647,0,1,1,0-5.186A3.655,3.655,0,0,1,103.931,49.026Z",
    transform: "translate(169.981 -34.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5302",
    "data-name": "Grupo 5302",
    transform: "translate(200.112 55.255)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5151",
    "data-name": "Caminho 5151",
    d: "M173.165,57.4V95.042a5,5,0,0,1-4.971,5.027H93.638a5,5,0,0,1-4.971-5.027V57.4a5,5,0,0,1,4.971-5.027h74.556A5,5,0,0,1,173.165,57.4Z",
    transform: "translate(-88.667 7.602)",
    fill: "#5a70fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5152",
    "data-name": "Caminho 5152",
    d: "M139.611,50.921v3.831a5.045,5.045,0,0,1-5.018,5.027H93.638a5,5,0,0,1-4.971-5.027V50.921a4.957,4.957,0,0,1,4.971-4.971h40.955A5,5,0,0,1,139.611,50.921Z",
    transform: "translate(-88.667 -45.95)",
    fill: "#5a70fd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5153",
    "data-name": "Caminho 5153",
    d: "M139.611,53.378v3.84a5.037,5.037,0,0,1-5.018,5.018H93.638a5,5,0,0,1-4.971-5.018v-3.84a4.957,4.957,0,0,1,4.971-4.971h40.955A5,5,0,0,1,139.611,53.378Z",
    transform: "translate(-88.667 -25.449)",
    fill: "#5a70fd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5300",
    "data-name": "Grupo 5300",
    transform: "translate(6.653 65.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5154",
    "data-name": "Caminho 5154",
    d: "M91.407,84.454A2.023,2.023,0,0,1,89.968,81l14.614-14.614a2.025,2.025,0,0,1,2.869,0l8.858,8.858,10.307-8.148a2.039,2.039,0,0,1,2.149-.234l15.726,7.718L157.1,53.88a2.03,2.03,0,0,1,3.467,2.112L146.985,78.259a2.038,2.038,0,0,1-2.626.766l-16.231-7.961L117.4,79.539a2.05,2.05,0,0,1-2.691-.159l-8.69-8.7L92.836,83.865A2.024,2.024,0,0,1,91.407,84.454Z",
    transform: "translate(-89.379 -52.91)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5301",
    "data-name": "Grupo 5301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5155",
    "data-name": "Caminho 5155",
    d: "M112.209,59.779H91.353a23.153,23.153,0,0,1,2-9.886,16.416,16.416,0,0,1,2.588-3.943h16.268a5,5,0,0,1,5.018,4.971v3.831A5.045,5.045,0,0,1,112.209,59.779Z",
    transform: "translate(-66.283 -45.95)",
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5156",
    "data-name": "Caminho 5156",
    d: "M115.68,53.378v3.84a5.037,5.037,0,0,1-5.018,5.018h-8.54A29.2,29.2,0,0,1,91.535,48.407h19.127A5,5,0,0,1,115.68,53.378Z",
    transform: "translate(-64.736 -25.449)",
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5157",
    "data-name": "Caminho 5157",
    d: "M173.165,57.4V95.042a5,5,0,0,1-4.971,5.027H93.638a5,5,0,0,1-4.971-5.027V75.111l2.112.486a94.012,94.012,0,0,1,11.073,4c1.346.542,2.757,1.028,4.214,1.514h.056c.7.215,1.458.43,2.214.645a46,46,0,0,0,11.559,1.4c.869.056,1.785,0,2.644,0,.71,0,1.411-.047,2.112-.1,5.513-.327,11.232-1.57,15.885-4.27a24.026,24.026,0,0,0,3.728-2.7,18.8,18.8,0,0,0,3.4-4.27,22.049,22.049,0,0,0,2.644-11.774,30.467,30.467,0,0,0-1.243-7.671h19.127A5,5,0,0,1,173.165,57.4Z",
    transform: "translate(-88.667 7.602)",
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5303",
    "data-name": "Grupo 5303",
    transform: "translate(0 2.63)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5158",
    "data-name": "Caminho 5158",
    d: "M112.149,85.216a25.928,25.928,0,0,1-18.585,7.728,26.207,26.207,0,0,1-21.66-11.4,25.706,25.706,0,0,1-4.653-14.913,7.639,7.639,0,0,1,.056-1.131A26.256,26.256,0,0,1,93.564,40.318a26.745,26.745,0,0,1,9.783,1.841,27.534,27.534,0,0,1,3.56,1.785,26.33,26.33,0,0,1,9.082,8.97L108.477,57.5,93.564,66.631Z",
    transform: "translate(-67.251 -40.318)",
    fill: "#d5e0ec"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5159",
    "data-name": "Caminho 5159",
    d: "M96.38,55.383a25.927,25.927,0,0,1-7.728,18.585L70.067,55.383,84.98,46.254l7.513-4.588A25.675,25.675,0,0,1,96.38,55.383Z",
    transform: "translate(-43.754 -29.07)",
    fill: "#5a70fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5160",
    "data-name": "Caminho 5160",
    d: "M106.907,43.944l-1.346,2.271-12,20.417-6.8,4.7L71.9,81.544a25.706,25.706,0,0,1-4.653-14.913,7.639,7.639,0,0,1,.056-1.131A26.256,26.256,0,0,1,93.564,40.318a26.745,26.745,0,0,1,9.783,1.841A27.534,27.534,0,0,1,106.907,43.944Z",
    transform: "translate(-67.251 -40.318)",
    fill: "#4eabef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5161",
    "data-name": "Caminho 5161",
    d: "M119.877,64.987A26.384,26.384,0,0,1,93.564,91.3,26.207,26.207,0,0,1,71.9,79.9a25.706,25.706,0,0,1-4.653-14.913,7.639,7.639,0,0,1,.056-1.131,14.428,14.428,0,0,1,11.4.215c2.915,1.4,5.4,3.784,8.055,5.616a12.933,12.933,0,0,0,5.616,2.429,14.017,14.017,0,0,0,4.971-.374,12.423,12.423,0,0,0,2.271-.7,13.734,13.734,0,0,0,7.4-5.672c1.56-2.813,1.785-6.27,1.458-9.512-.056-.43-.112-.813-.159-1.243a39.02,39.02,0,0,0-2.757-10.045,19.314,19.314,0,0,0-1.243-2.6,8.793,8.793,0,0,0-.972-1.458,27.534,27.534,0,0,1,3.56,1.785,26.33,26.33,0,0,1,9.082,8.97A25.675,25.675,0,0,1,119.877,64.987Z",
    transform: "translate(-67.251 -38.674)",
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5305",
    "data-name": "Grupo 5305",
    transform: "translate(473.651 121.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5162",
    "data-name": "Caminho 5162",
    d: "M148.061,56.147l-8.484,21.435a2.15,2.15,0,0,1-2.785,1.2l-31.63-12.521a2.133,2.133,0,0,1-1.2-2.775l8.484-21.426a2.155,2.155,0,0,1,2.766-1.205l31.63,12.521a2.041,2.041,0,0,1,1.112,1.009A2.084,2.084,0,0,1,148.061,56.147Z",
    transform: "translate(-103.814 -40.701)",
    fill: "#d5e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5163",
    "data-name": "Caminho 5163",
    d: "M139.1,54.381,118.461,59.5a1.91,1.91,0,0,1-2.037-.813L104.875,40.832a2.04,2.04,0,0,1,1.486.019l31.63,12.521A2.041,2.041,0,0,1,139.1,54.381Z",
    transform: "translate(-94.958 -40.701)",
    fill: "#b6c3e0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5306",
    "data-name": "Grupo 5306",
    transform: "translate(170.51 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1348",
    "data-name": "Ret\\xE2ngulo 1348",
    width: 41.09,
    height: 45.383,
    rx: 0.64,
    transform: "translate(23.786 0) rotate(31.609)",
    fill: "#d5e0ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1349",
    "data-name": "Ret\\xE2ngulo 1349",
    width: 18.399,
    height: 5.724,
    rx: 0.208,
    transform: "translate(24.054 10.486) rotate(31.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1350",
    "data-name": "Ret\\xE2ngulo 1350",
    width: 29.745,
    height: 4.986,
    rx: 0.247,
    transform: "translate(18.857 18.93) rotate(31.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1351",
    "data-name": "Ret\\xE2ngulo 1351",
    width: 29.745,
    height: 4.986,
    rx: 0.247,
    transform: "translate(14.331 26.285) rotate(31.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1352",
    "data-name": "Ret\\xE2ngulo 1352",
    width: 29.745,
    height: 4.986,
    rx: 0.247,
    transform: "translate(9.805 33.64) rotate(31.609)",
    fill: "#fff"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5164",
    "data-name": "Caminho 5164",
    d: "M81.141,39.747a4.253,4.253,0,0,0-1.047,4.13L68.526,55.445a9.624,9.624,0,1,0,0,16.259L78.561,81.739a6.218,6.218,0,1,0,2.981-2.99L71.516,68.723a9.648,9.648,0,0,0,0-10.288L83.084,46.867a4.232,4.232,0,0,0,4.13-1.047,4.295,4.295,0,1,0-6.074-6.074Z",
    transform: "translate(-53.751 -27.801)",
    fill: "#d5e0ec"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5316",
    "data-name": "Grupo 5316",
    transform: "translate(361.813 6.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5165",
    "data-name": "Caminho 5165",
    d: "M175.389,37.948H125.043L114.83,46.432H92.573a1.651,1.651,0,0,0-1.514,1.075,1.906,1.906,0,0,0,.056,1.243l3.831,8.755,1.14,2.588,4.971,11.456a3.034,3.034,0,0,0,2.8,1.785h2.869c-.7,2.271-1.355,4.756-2,7.4l-.654,2.6c-2.747,11.83-5.186,26.687-6.859,39.815a1.689,1.689,0,0,0,1.243,1.3,9.735,9.735,0,0,1-1.075,2.971,1.343,1.343,0,0,0-.654.1c-2.271,1.243-8.045,3.242-9.456,5.242,0,.056-.047.056-.047.112.43,1.729,19.931,1.775,21.772-2,.047-2.215-.383-3.784-1.626-4.326h-.757c-.159-.374-.271-.757-.43-1.187.86,0,1.673,0,2.215-.056l3.4-12.586,7.886-29.387.71-2.6.589-2.271c1.355-2.158,3.672-3.457,6.6-4.485a56.549,56.549,0,0,0-.542,6.756c-.056.813-.112,1.673-.112,2.6a265.233,265.233,0,0,0,1.729,29.387l.168,1.944c.43,4,.916,8,1.4,11.886.215,1.729.486,3.457.7,5.13.159.542.757.813,1.57.925a11.291,11.291,0,0,1-.327,3.074v.056a.922.922,0,0,0-.542.327c-.7.645-1.729,1.458-2.915,2.429-2.056,1.673-4.326,3.569-4.859,5.074v.112c.318.645,3.56.159,7.4-.869,5.672-1.5,12.586-4.317,13.016-6.746-.056-.112-.056-.271-.1-.383-.486-1.944-1.355-3.242-2.542-3.4a1.258,1.258,0,0,0-.757.215,7.586,7.586,0,0,1-.7-1.075c.8-.224,1.56-.439,2.1-.6v-4.27l-.056-13.829-.1-29.387V82.3a7.707,7.707,0,0,1,.645-1.57c4-7.186,19.183-9.615,25.182-20.641a10.857,10.857,0,0,0,.757-1.458c.7.056,1.458.168,2.158.224a12.592,12.592,0,0,0,.271-1.411,49.031,49.031,0,0,0,.916-9.942c0-1.729-.056-3.56-.112-5.457A41,41,0,0,0,175.389,37.948ZM134.172,48.591c-1.028.43-2.056.813-3.084,1.243l-.7-1.57a2.355,2.355,0,0,0-.542-.757,2.626,2.626,0,0,0-1.075-.7c2-1.3,3.831-2.588,5.616-3.831-.374,1.4-.813,2.859-1.355,4.373l.168.159C133.472,47.946,133.9,48.208,134.172,48.591Z",
    transform: "translate(-79.36 35.81)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5315",
    "data-name": "Grupo 5315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5309",
    "data-name": "Grupo 5309",
    transform: "translate(36.601 71.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5308",
    "data-name": "Grupo 5308",
    transform: "translate(0 88.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5166",
    "data-name": "Caminho 5166",
    d: "M105.386,52.716l-9.447,4.3a.162.162,0,0,1-.14.075l-3.317,1.476-1.729.794a2.05,2.05,0,0,0,.262-.336c2.14-2.476,3.355-4.448,3.878-6.662a11.027,11.027,0,0,0,.308-3.168,10.928,10.928,0,0,0-.028-1.093l5.7-.748,1.617-.215a7.867,7.867,0,0,0,.392.9,12.389,12.389,0,0,0,.729,1.056C104.6,50.567,105.75,51.6,105.386,52.716Z",
    transform: "translate(-86.548 -47.138)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5167",
    "data-name": "Caminho 5167",
    d: "M110.757,51.086C110.01,55.225,91.2,60.3,90.3,58.72l.037-.112c.841-2.3,5.868-5.737,7.756-7.531a.91.91,0,0,1,.551-.271c1.224-.346,3.551.215,5.167-.009a2.409,2.409,0,0,0,1.149-.346c.785-.6,1.439-2.336,2.4-2.915a1.035,1.035,0,0,1,.729-.206C109.412,47.507,110.262,48.918,110.757,51.086Z",
    transform: "translate(-90.303 -45.582)",
    fill: "#ee4e6f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5168",
    "data-name": "Caminho 5168",
    d: "M133.3,51.422c-4.429,15.352-24.734,16.791-27.49,26.126l.159,48.524c-.523.168-1.252.383-2.093.6a17.667,17.667,0,0,1-2.018.523,16.784,16.784,0,0,1-5.662.635,1.8,1.8,0,0,1-1.57-.906c-3.27-23.64-5.775-53.27-2.336-61.745,4.747-11.914,16.212-17.4,27.808-27.462l6.307,6.55Z",
    transform: "translate(-87.538 -37.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5169",
    "data-name": "Caminho 5169",
    d: "M136.061,45.573c-4.429,15.352-24.734,16.791-27.49,26.126l.159,48.524c-.523.168-1.252.383-2.093.6a12.4,12.4,0,0,0,.729,1.056,1.035,1.035,0,0,1,.729-.206c1.317.178,2.168,1.588,2.663,3.756-.747,4.139-19.557,9.213-20.454,7.634l.037-.112c1.467-.318,2.971-.673,4.429-1.14a12.091,12.091,0,0,0,1.467-.458,15.856,15.856,0,0,0,3.317-1.476.162.162,0,0,0,.14-.075,10.169,10.169,0,0,0,3.541-3.5,7.888,7.888,0,0,0,.579-1.159,11.563,11.563,0,0,0,.8-3.794c.009-.383.028-.776.009-1.205a45.117,45.117,0,0,0-.57-5.7,182.5,182.5,0,0,1-1.645-37.161c.178-2.943.449-5.962,1.766-8.615,3.766-7.4,14.035-8.615,19.828-14.567a15.715,15.715,0,0,0,3.859-6.952c.6-2.252-.3-5.354.411-7.372a3.3,3.3,0,0,1,.888-1.355Z",
    transform: "translate(-90.303 -31.865)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5311",
    "data-name": "Grupo 5311",
    transform: "translate(0 72.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5310",
    "data-name": "Grupo 5310",
    transform: "translate(0 79.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5170",
    "data-name": "Caminho 5170",
    d: "M102.7,53.521,92.462,55.175a.237.237,0,0,1-.15.037l-3.6.542-1.869.318a2.627,2.627,0,0,0,.336-.252c2.719-1.831,4.41-3.411,5.494-5.41a10.745,10.745,0,0,0,1.131-2.971c.1-.336.187-.682.271-1.065l5.681.785,1.617.206a7.554,7.554,0,0,0,.15.972,9.781,9.781,0,0,0,.42,1.215C102.516,51.232,103.357,52.54,102.7,53.521Z",
    transform: "translate(-82.548 -46.373)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5171",
    "data-name": "Caminho 5171",
    d: "M108.13,51.1c-1.813,3.794-21.3,3.747-21.744,1.981l.056-.093c1.42-2.009,7.176-4,9.475-5.223a.891.891,0,0,1,.6-.121c1.271-.009,3.373,1.14,4.99,1.346a2.34,2.34,0,0,0,1.2-.028c.916-.374,2.009-1.869,3.084-2.177a1.08,1.08,0,0,1,.766-.009C107.775,47.294,108.223,48.873,108.13,51.1Z",
    transform: "translate(-86.386 -43.603)",
    fill: "#ee4e6f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5172",
    "data-name": "Caminho 5172",
    d: "M144.641,54.554c-8.326,13.652-28.284,9.69-33.4,17.969L98.621,119.373c-.551.028-1.308.037-2.177.028a17.5,17.5,0,0,1-2.093-.019,17.085,17.085,0,0,1-5.625-.878c-.729-.308-1.215-.738-1.271-1.3,3.065-23.659,8.447-52.9,13.988-60.185,7.718-10.232,20.23-12.512,34.059-19.165l4.364,7.98Z",
    transform: "translate(-77.466 -37.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5173",
    "data-name": "Caminho 5173",
    d: "M153.56,47.428c-8.326,13.652-28.284,9.69-33.4,17.969l-12.624,46.851c-.551.028-1.308.037-2.177.028a9.776,9.776,0,0,0,.42,1.215,1.08,1.08,0,0,1,.766-.009c1.224.523,1.673,2.1,1.579,4.326-1.813,3.794-21.3,3.747-21.744,1.981l.056-.094c1.5.075,3.046.122,4.579.065a12.009,12.009,0,0,0,1.532-.065,15.778,15.778,0,0,0,3.6-.542.237.237,0,0,0,.15-.037,10.194,10.194,0,0,0,4.336-2.448,7.172,7.172,0,0,0,.869-.972,11.319,11.319,0,0,0,1.766-3.439c.122-.374.234-.748.327-1.159a42.493,42.493,0,0,0,.953-5.653,181.854,181.854,0,0,1,8.2-36.283c.934-2.794,1.99-5.644,3.962-7.849,5.588-6.148,15.81-4.625,22.958-8.84a15.726,15.726,0,0,0,5.56-5.681c1.168-2.028,1.112-5.261,2.336-7.017a3.284,3.284,0,0,1,1.215-1.065Z",
    transform: "translate(-86.386 -30.73)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5312",
    "data-name": "Grupo 5312",
    transform: "translate(18.043 26.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5174",
    "data-name": "Caminho 5174",
    d: "M128.095,66.86c-.953,6.466-19.183,16.922-33.807,25.715-1.093.635-2.121,1.271-3.149,1.869l-2.822-4.98L117.386,65.3l.5-18.3,4.7-14.063c1.168,5.373,2.439,11.241,3.495,16.6C127.674,57.74,128.767,64.776,128.095,66.86Z",
    transform: "translate(-88.317 -32.306)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5175",
    "data-name": "Caminho 5175",
    d: "M92.222,61.036s9.774,3.3,12.68.477-.944-28.378-2.626-28.621-10.054,2.177-10.054,2.177C90.139,42.021,91.522,57.233,92.222,61.036Z",
    transform: "translate(-64.928 -32.873)",
    fill: "#5a70fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5176",
    "data-name": "Caminho 5176",
    d: "M123.043,52.033c-.953,6.466-19.183,16.922-33.807,25.715a2.58,2.58,0,0,1-.28-.953,5.221,5.221,0,0,1,1.056-3.467c4.027-6.317,11.979-8.718,17.875-13.418a34.087,34.087,0,0,0,9.858-13.568,58.7,58.7,0,0,0,3.28-11.624C122.622,42.913,123.716,49.949,123.043,52.033Z",
    transform: "translate(-83.265 -17.479)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5177",
    "data-name": "Caminho 5177",
    d: "M129.54,95.167c-11.764-1.205-22.753-2.121-30.312-5.588a17.7,17.7,0,0,1-7.531-5.9c3.429-9.783,3.252-15.894,2.233-22.641-.392-2.551-.888-5.2-1.346-8.2a107.529,107.529,0,0,1-1.346-17.09c5.868-4.663,28.938-3.149,35.087,0,.206,2.046.421,4.093.663,6.111.43,3.85.888,7.662,1.308,11.372.318,2.719.607,5.373.925,7.952C130.7,75.171,131.549,87.355,129.54,95.167Z",
    transform: "translate(-45.892 -7.215)",
    fill: "#5a70fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5178",
    "data-name": "Caminho 5178",
    d: "M122.406,87.07c-11.764-1.205-22.753-2.121-30.312-5.588a8.221,8.221,0,0,1,2.616-.5c3.738-.1,7.559.252,11.157-.776a16.343,16.343,0,0,0,10.316-9.073c1.906-4.317-.15-9.4-1.813-13.82-1.2-3.214-3.14-7.008-3.14-10.465.037-2.336,3.009-3.766,4.037-5.849,1.028-2.121,2.476-5.476,4.588-7.242.43,3.85.888,7.662,1.308,11.372.318,2.719.607,5.373.925,7.952C123.565,67.074,124.415,79.258,122.406,87.07Z",
    transform: "translate(-38.758 0.882)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5179",
    "data-name": "Caminho 5179",
    d: "M128.021,43.281a118.524,118.524,0,0,1-35.293-.14c-.392-2.551-.888-5.2-1.345-8.2a142.468,142.468,0,0,0,35.713.392C127.414,38.049,127.7,40.7,128.021,43.281Z",
    transform: "translate(-44.691 10.686)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5313",
    "data-name": "Grupo 5313",
    transform: "translate(3.728 75.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5180",
    "data-name": "Caminho 5180",
    d: "M123.391,53.851H90.584a2.248,2.248,0,0,1-1.5-3.915l10.867-9.877a2.268,2.268,0,0,1,1.514-.579h32.807a2.25,2.25,0,0,1,1.514,3.915L124.9,53.262A2.215,2.215,0,0,1,123.391,53.851Z",
    transform: "translate(-73.848 -26.95)",
    fill: "#b6c3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5181",
    "data-name": "Caminho 5181",
    d: "M134.711,65.041H99.671a3.032,3.032,0,0,1-2.766-1.8L86.926,40.428a1.63,1.63,0,0,1,1.486-2.289h35.04a3.032,3.032,0,0,1,2.766,1.8L136.2,62.761A1.621,1.621,0,0,1,134.711,65.041Z",
    transform: "translate(-86.785 -38.139)",
    fill: "#ebf2f8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_384",
    "data-name": "Elipse 384",
    cx: 3.282,
    cy: 4.45,
    rx: 3.282,
    ry: 4.45,
    transform: "translate(17.598 13.832) rotate(-54.425)",
    fill: "#b6c3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5314",
    "data-name": "Grupo 5314",
    transform: "translate(49.801 28.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5182",
    "data-name": "Caminho 5182",
    d: "M128.263,65.821c0,7.027-18.978,21.51-32.471,32.742l-.177-.215-3.355-4.27,25.192-28.191-1.131-2.9-5.476-13.848,6.961-16.034c3.28,8.69,7.13,18.856,9.148,25.677.28,1.028.561,1.981.738,2.831A12.09,12.09,0,0,1,128.263,65.821Z",
    transform: "translate(-87.174 -33.108)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5183",
    "data-name": "Caminho 5183",
    d: "M101.125,63.149s9.269-1.607,11.727-4.831S105,33.108,103.3,33.108,92.51,43.461,94.211,49.236,101.125,63.149,101.125,63.149Z",
    transform: "translate(-72.66 -33.108)",
    fill: "#5a70fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5184",
    "data-name": "Caminho 5184",
    d: "M100.335,44.119H95.672l-2.014,3-1.943-4.487L92.7,40.3l4.1-.671,3.356,4.274Z",
    transform: "translate(-91.716 21.337)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5185",
    "data-name": "Caminho 5185",
    d: "M125.392,40.364c0,7.027-18.978,21.51-32.471,32.742H92.6c.037-.065.1-.14.14-.215a.611.611,0,0,1,.112-.14,119.976,119.976,0,0,1,17.66-18.511c5.261-4.41,11.129-8.755,13.53-15.184a17.5,17.5,0,0,0,.776-2.9A12.09,12.09,0,0,1,125.392,40.364Z",
    transform: "translate(-84.304 -7.65)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5186",
    "data-name": "Caminho 5186",
    d: "M103.393,42.751a3.339,3.339,0,0,1-1.56,2.962c-3.457,2.551-11.306,1.523-7.7-3.317a1.885,1.885,0,0,0,.1-.635c.355-2.364-.635-5.868-1.831-9.5l8.755-.635C100.776,35.892,102.01,39.321,103.393,42.751Z",
    transform: "translate(-36.171 -16.974)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5187",
    "data-name": "Caminho 5187",
    d: "M103.393,42.751a3.339,3.339,0,0,1-1.56,2.962,6.134,6.134,0,0,0-.065-2.289,3.733,3.733,0,0,0-2.551-2.084c-1.617-.43-3.317.28-4.98.42.355-2.364-.635-5.868-1.831-9.5l8.755-.635C100.776,35.892,102.01,39.321,103.393,42.751Z",
    transform: "translate(-36.171 -16.974)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5188",
    "data-name": "Caminho 5188",
    d: "M110.663,47.711c-.252.28-.533.6-.813.878-2.794,2.616-7.914,5.018-10.774,3.354-1.738-1.374-2.971-4.13-4.027-7.6-1.131-3.775-2.121-8.335-3.364-12.857L107.2,30.219Z",
    transform: "translate(-42.171 -28.681)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5189",
    "data-name": "Caminho 5189",
    d: "M110.663,47.711c-.252.28-.533.6-.813.878a4.4,4.4,0,0,1-1.8-.318c-2.018-.916-2.439-3.812-4.382-4.943a6.557,6.557,0,0,0-3.887-.355,17.373,17.373,0,0,0-3.495.738,11.037,11.037,0,0,0-1.233.635c-1.131-3.775-2.121-8.335-3.364-12.857L107.2,30.219Z",
    transform: "translate(-42.171 -28.681)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5190",
    "data-name": "Caminho 5190",
    d: "M106.7,42.544l.748,3.859,1.215-1.149s-1.327-3.812.187-4.345,2.57.757,2.644,2.383-1.925,6.681.318,8.083,5.952-1.766,5.653-4.868,1.224-13.147-5.018-15.567-8.456.953-12.764.43-8.8-1.075-8.419,2.514c.4,3.784,3.728,10.465,6.6,8.5S106.7,42.544,106.7,42.544Z",
    transform: "translate(-45.904 -30.054)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5324",
    "data-name": "Grupo 5324",
    transform: "translate(0 92.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5317",
    "data-name": "Grupo 5317",
    transform: "translate(1.584 137.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5191",
    "data-name": "Caminho 5191",
    d: "M60.058,69.07c-.57,1.308.243,3.532.7,5.747l-7.793-2.7c1.028-1.318,1.962-2.672,1.794-4.494Z",
    transform: "translate(-50.181 37.592)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5192",
    "data-name": "Caminho 5192",
    d: "M80.14,106.6c-1.766,12.521-9.877,35.554-16.95,56.821l-3.439-.766-3.448-.766,7.765-58.269c-5.335-16.2-10.951-28.135-11.4-47.253l15.3.093,8.269.075C81.6,74.265,81.924,95.551,80.14,106.6Z",
    transform: "translate(-52.668 -56.362)",
    fill: "#5a70fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5193",
    "data-name": "Caminho 5193",
    d: "M54.923,68.006c-.841,1.168-2.2,3.336-2.158,4.868C53.456,74,68.64,75.388,68.771,74.351c0-1.551-4.186-3.467-6.13-4.28A14.379,14.379,0,0,1,54.923,68.006Z",
    transform: "translate(-51.868 40.796)",
    fill: "#ee4e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5194",
    "data-name": "Caminho 5194",
    d: "M73.815,106.512c-1.766,12.521-9.877,35.554-16.95,56.821l-3.439-.766c4.167-17.716,10.606-34.919,13.867-52.8a102.349,102.349,0,0,0,1.336-31.751,68.288,68.288,0,0,0-3.925-15.8c-.4-1.084-1.953-3.457-3.065-5.84l8.269.075C75.272,74.182,75.6,95.467,73.815,106.512Z",
    transform: "translate(-46.343 -56.279)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5319",
    "data-name": "Grupo 5319",
    transform: "translate(16.235 57.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5318",
    "data-name": "Grupo 5318",
    transform: "translate(4.111 6.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5195",
    "data-name": "Caminho 5195",
    d: "M95.472,50.933c-5.522,13.222-11.633,30.2-17.24,32.05C73.9,84.6,63.777,85.17,58.292,82.815L54.676,68.07l18.4,5.046,18.4-24.556Z",
    transform: "translate(-54.676 -48.56)",
    fill: "#ffc8c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5196",
    "data-name": "Caminho 5196",
    d: "M54.236,50.453l16.4,4.261s2.682,15.109.243,15.193S59,67.319,59,67.319Z",
    transform: "translate(-54.236 -25.89)",
    fill: "#eff5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5197",
    "data-name": "Caminho 5197",
    d: "M59.4,54.7l-.878-3.691.747-3.149s2.317-.579,3.971,2.971a7.149,7.149,0,0,1,.159,6.242Z",
    transform: "translate(-18.49 -47.824)",
    fill: "#ffc8c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5198",
    "data-name": "Caminho 5198",
    d: "M65.409,61.374,62.12,60.4l-8-2.429a10.034,10.034,0,0,0,2.859-4.111A20.84,20.84,0,0,0,58.335,49.6l7.073,1.944C64.39,55.1,64.166,58.459,65.409,61.374Z",
    transform: "translate(-38.96 24.903)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5199",
    "data-name": "Caminho 5199",
    d: "M62.855,61.374,59.566,60.4c.1-.757.159-1.57.271-2.327a2.151,2.151,0,0,0-.271-1.729,2.771,2.771,0,0,0-1.084-.645,32.91,32.91,0,0,1-3.13-1.3,5.009,5.009,0,0,1-.925-.542A20.842,20.842,0,0,0,55.782,49.6l7.073,1.944C61.837,55.1,61.613,58.459,62.855,61.374Z",
    transform: "translate(-36.407 24.903)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5200",
    "data-name": "Caminho 5200",
    d: "M70.892,57.253c.056,5.41-.916,11.185-1.5,11.886-1.243,1.355-12.484-.318-12.484-1.56v-.112l-2.542-8.045a8.878,8.878,0,0,1,9.456-11.512l4.859.542C70.248,49.965,70.846,53.534,70.892,57.253Z",
    transform: "translate(-40.501 10.327)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5201",
    "data-name": "Caminho 5201",
    d: "M70.892,57.253c-.7.112-1.458.327-2.158.439a6.245,6.245,0,0,0-1.346.43,8.468,8.468,0,0,0-1.411.916,37.086,37.086,0,0,0-7.13,6.812c-.486.7-1.131,1.56-1.944,1.729v-.112l-2.542-8.045a8.878,8.878,0,0,1,9.456-11.512l4.859.542C70.248,49.965,70.846,53.534,70.892,57.253Z",
    transform: "translate(-40.501 10.327)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5320",
    "data-name": "Grupo 5320",
    transform: "translate(15.805 139.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5202",
    "data-name": "Caminho 5202",
    d: "M62.616,68.7c-.392,1.374.7,3.476,1.43,5.616l-8.073-1.691c.86-1.439,1.607-2.906,1.215-4.681Z",
    transform: "translate(-39.321 38.664)",
    fill: "#ffc8c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5203",
    "data-name": "Caminho 5203",
    d: "M87.8,105.692c-.168,12.642-5.3,36.526-9.624,58.512l-3.5-.327-3.513-.318.327-58.783c-7.354-15.4-14.427-26.528-17.3-45.431L69.374,57.5l8.213-.972C85.147,73.446,88.174,94.517,87.8,105.692Z",
    transform: "translate(-54.19 -56.533)",
    fill: "#5a70fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5204",
    "data-name": "Caminho 5204",
    d: "M57.378,68.343c-.682,1.271-1.757,3.579-1.523,5.1.822,1.028,16.062.486,16.062-.57-.206-1.532-4.6-2.9-6.625-3.467A14.379,14.379,0,0,1,57.378,68.343Z",
    transform: "translate(-40.568 42.01)",
    fill: "#ee4e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5205",
    "data-name": "Caminho 5205",
    d: "M74.241,105.692c-.168,12.642-5.3,36.526-9.624,58.512l-3.5-.327c1.887-18.1,6.1-35.975,7.073-54.13a102.151,102.151,0,0,0-2.7-31.658A68.119,68.119,0,0,0,59.6,62.906c-.542-1.028-2.383-3.186-3.784-5.4l8.213-.972C71.588,73.446,74.615,94.517,74.241,105.692Z",
    transform: "translate(-40.631 -56.533)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5206",
    "data-name": "Caminho 5206",
    d: "M95.159,114.47c-6.214,4.7-31.34,6.26-39.17,2.915a5.064,5.064,0,0,1-2-1.458C53.232,99.557,48.261,61.3,62.043,52.5c5.5-4,19.557-1.514,27.173,2.915l.757.43a12.427,12.427,0,0,1,2.813,2.271c.318,3.943.486,7.784.533,11.456.056,1.345.056,2.756.056,4.055V74.7C93.374,90.26,92.187,103.388,95.159,114.47Z",
    transform: "translate(-52.499 32.32)",
    fill: "#eff5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5207",
    "data-name": "Caminho 5207",
    d: "M67.057,60.136c8.139-.42,9.082-1.729,8.092-6.784-2.168-11.11-5.242-3.541-16.829-1.047-7.634,1.645-4.84,16.221.336,19.081,5.859,3.233,7.728.832,6.9-1.934s-5.4-3.971-2.8-5.821,4.326,2.457,4.326,2.457l1.056-.878S64.954,60.239,67.057,60.136Z",
    transform: "translate(-43.188 7.089)",
    fill: "#051a2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5321",
    "data-name": "Grupo 5321",
    transform: "translate(37.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5208",
    "data-name": "Caminho 5208",
    d: "M59.489,54.337l6.989,23.127C67.6,81.164,71.861,83,76.14,81.6l1.448-.477c5.177-1.682,7.9-7.195,5.541-11.2L70.5,48.385Z",
    transform: "translate(-31.586 14.757)",
    fill: "#d5e0ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1353",
    "data-name": "Ret\\xE2ngulo 1353",
    width: 52.773,
    height: 30.023,
    rx: 1.448,
    transform: "translate(0 52.761) rotate(-24.429)",
    fill: "#b6c3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5209",
    "data-name": "Caminho 5209",
    d: "M81.281,107.125l47.262-8.195L102.52,41.642l-37.264,30.2A13.892,13.892,0,0,0,61.35,88.381l4.906,10.8A13.907,13.907,0,0,0,81.281,107.125Z",
    transform: "translate(-26.439 -41.507)",
    fill: "#b6c3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5210",
    "data-name": "Caminho 5210",
    d: "M94.042,99.051C88.2,101.7,77.615,91.062,70.43,75.233S62.16,44.435,68,41.791c3.616-1.682,12.372,9.83,19.557,25.659S97.658,97.434,94.042,99.051Z",
    transform: "translate(8.072 -41.628)",
    fill: "#b6c3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5211",
    "data-name": "Caminho 5211",
    d: "M92.055,99.051c-3.626,1.626-12.372-9.886-19.557-25.659-7.185-15.829-10.054-29.985-6.485-31.6,3.616-1.682,12.372,9.83,19.557,25.659S95.671,97.434,92.055,99.051Z",
    transform: "translate(10.059 -41.628)",
    fill: "#d5e0ec"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_385",
    "data-name": "Elipse 385",
    cx: 5.191,
    cy: 22.769,
    rx: 5.191,
    ry: 22.769,
    transform: "translate(74.952 10.195) rotate(-24.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5323",
    "data-name": "Grupo 5323",
    transform: "translate(36.717 73.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5322",
    "data-name": "Grupo 5322",
    transform: "translate(3.569 6.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5212",
    "data-name": "Caminho 5212",
    d: "M100.456,53.421c-.645.86-1.243,1.729-1.887,2.644-8,11.129-16.8,24.1-22.258,24.584A31.98,31.98,0,0,1,66.1,79.678a26.563,26.563,0,0,1-8.7-3.457l-.486-.327-.056-3.887-.047-11.3,11.344,6.158,5.4,2.971,23.556-19.66Z",
    transform: "translate(-56.81 -50.179)",
    fill: "#ffc8c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5213",
    "data-name": "Caminho 5213",
    d: "M71.388,58.9s0,.383-.047.972c-.112,1.682-.439,5.3-.972,8.428a19.209,19.209,0,0,1-1.084,4.382c-.327.757-.7,1.187-1.131,1.075-1.411-.271-4.924-2-7.569-3.457-1.888-.972-3.4-1.785-3.4-1.785l-.215-4.7-.542-12.8.757.43Z",
    transform: "translate(-56.428 -36.506)",
    fill: "#eff5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5214",
    "data-name": "Caminho 5214",
    d: "M61.122,56.145V52.361l1.448-2.9s2.392-.019,3.186,3.812a7.149,7.149,0,0,1-1.289,6.1Z",
    transform: "translate(-17.261 -49.464)",
    fill: "#ffc8c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5215",
    "data-name": "Caminho 5215",
    d: "M131.427,50.809c-8,11.129-16.8,24.1-22.258,24.584a31.98,31.98,0,0,1-10.213-.972c-.327.757-.7,1.187-1.131,1.075-1.411-.271-4.924-2-7.569-3.457,0,15.558-1.187,28.686,1.785,39.768-6.214,4.7-31.34,6.261-39.17,2.915.813,0,1.626.056,2.429.1a42.37,42.37,0,0,0,18.268-3.289c4.046-1.729,8.2-4.7,8.8-9.082.327-2.7-.7-5.345-.813-7.989-.056-4.111,2.158-7.84,3.354-11.783a25.319,25.319,0,0,0-.271-16.1,5.717,5.717,0,0,0-1.458-2.317c1.131.43,2.317.86,3.457,1.289,1.028.439,2.046.813,3.074,1.2l.486.159c1.243.486,2.542.972,3.784,1.458,1.944.757,14.437,3.355,16.539,1.888,4.429-2.971,8.615-7.662,13.044-10.634,2.7-1.831,4.4-5.513,6.83-7.784C130.727,51.51,131.1,51.183,131.427,50.809Z",
    transform: "translate(-49.382 34.983)",
    opacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/Banner.d2891262.svg";
export { ForwardRef as ReactComponent };